import React from 'react'
import { func, object, array } from 'prop-types'

import moment from 'moment'

import { Button } from 'react-bootstrap'
import QueryEditor from 'coact/QueryEditor'

import stateSpliter from 'coact-utils/stateSpliter'

import DateRow from './DateRow'


function AttendanceChecker (props) {
  const {
    query, setQuery, fields, schema, clickFetch,
    data, createGate, delGate,
    commentByDate, setComments, createComment,
  } = props

  const linkComment = stateSpliter(commentByDate, setComments)

  return (
    <div>
      <h1>出勤查核</h1>
      <div>
        <QueryEditor
          {...{
            value: query,
            onChange: setQuery,
            fields,
            schema,
          }}
        />
        <div>
          <Button bsStyle="primary" onClick={clickFetch}>查詢</Button>
        </div>
      </div>
      <div>
        {data.map(({ _id, name, items }) => (
          <div key={_id}>
            <h3>{name}</h3>
            {items.map(dateData => (
              <DateRow
                key={dateData.dateStr}
                data={dateData}
                delGate={delGate}
                createGate={createGate(_id)}
                createComment={createComment(_id)}
                {...linkComment(
                  moment(dateData.dateStr).format('YYYY-MM-DD'),
                  { },
                  'comment',
                  'setComment',
                )}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

AttendanceChecker.propTypes = {
  query: object.isRequired,
  setQuery: func.isRequired,
  fields: array.isRequired,
  schema: object.isRequired,

  clickFetch: func.isRequired,

  data: array.isRequired,
  commentByDate: object.isRequired,
  setComments: func.isRequired,
  createComment: func.isRequired,

  createGate: func.isRequired,
  delGate: func.isRequired,
}

export default AttendanceChecker



// WEBPACK FOOTER //
// ./src/components/AttendanceChecker/AttendanceChecker.jsx